import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface FeatureTourState {
  autoCreateJob: boolean;
  setAutoCreateJob: (value?: boolean) => void;
  clearAutoCreateJob: () => void;
}

export const useFeatureTourStore = create<FeatureTourState>()(
  devtools(
    (set) => ({
      autoCreateJob: false,
      setAutoCreateJob: (value = true) =>
        set(
          { autoCreateJob: value },
          undefined,
          "featureTour/setAutoCreateJob",
        ),
      clearAutoCreateJob: () =>
        set(
          { autoCreateJob: false },
          undefined,
          "featureTour/clearAutoCreateJob",
        ),
    }),
    { name: "FeatureTourStore" },
  ),
);
